import { Container, Texture, Sprite } from 'pixi.js';
import { InteractionEvents } from '@cc/pixi-app';
import { ButtonBase } from "./../common/ButtonBase";
import { app } from "./../app";
import avatarConfig from "../../data/avatar-config.json";
import { avatarGenerator } from './../common/AvatarGenerator';

export class PartCarousel {
    constructor(parts, yPos, creator, type, color, out) {
        this.type = type;
        this.color = color;
        this.container = new Container();
        this.creator = creator;
        this.leftArrow = new ButtonBase(new Texture.from("left-avatar-inactive"));
        this.leftArrow.anchor.set(0, 0.5);
        this.leftArrow.interactiveChildren = false;
        this.rightArrow = new ButtonBase(new Texture.from("right-avatar-inactive"));
        this.rightArrow.anchor.set(1, 0.5);
        this.rightArrow.interactiveChildren = false;

        this.previousObject = new Sprite.from("avatar_blank");
        this.previousObject.anchor.set(0.5);
        this.previousObject.position.set(150, 0);
        this.previousObject.scale.set(avatarConfig.parts[this.type[0]].iconScale);
        this.leftArrow.addChild(this.previousObject);
        this.nextObject = new Sprite.from("avatar_blank");
        this.nextObject.anchor.set(0.5);
        this.nextObject.position.set(-150, 0);
        this.nextObject.scale.set(avatarConfig.parts[this.type[0]].iconScale);
        this.rightArrow.addChild(this.nextObject);

        this.container.addChild(this.leftArrow);
        this.container.addChild(this.rightArrow);
        this.container.y = yPos;

        this.leftArrow.on(InteractionEvents.PointerTap, ()=> {
            app.sound.play("03-ui-swipe");
            this.onArrowPressed(-1);
        });
        this.rightArrow.on(InteractionEvents.PointerTap, ()=> {
            app.sound.play("03-ui-swipe");
            this.onArrowPressed(1);
        });

        this.creator.ee.on("carousel:selected", (c)=> this.setActiveState(c));

        this.positionArrows(out);
        this.creator.on("resize", this.positionArrows, this);

        this.dna = avatarGenerator.dna;
        this.parts = [];

        for (var i = 0; i < parts.length; i ++){
            this.parts.push([Object.keys(parts[i])]);
        }
        for (var j = 0; j < this.parts.length; j++){
            if (this.parts[j][0].indexOf("color") !== -1){
                this.parts[j][0].splice(this.parts[j][0].indexOf("color"), 1);
            }
            if (this.parts[j][0].indexOf("iconScale") !== -1){
                this.parts[j][0].splice(this.parts[j][0].indexOf("iconScale"), 1);
            }
        }
        if (this.activeState){
            this.setColourWheel();
        }
        this.setInitialPos(type);
    }

    positionArrows(out) {
        if (out){
            this.leftArrow.x = -(app.resizer.width / 2) - this.leftArrow.width;
            this.rightArrow.x = (app.resizer.width / 2) + this.rightArrow.width;
        }
        else{
            this.leftArrow.x = -(app.resizer.width / 2);
            this.rightArrow.x = (app.resizer.width / 2);
        }
    }

    setActiveState(carousel) {
        if (carousel === this) {
            this.leftArrow.texture = new Texture.from("left-avatar-select");
            this.rightArrow.texture = new Texture.from("right-avatar-select");
        }
        else {
            this.leftArrow.texture = new Texture.from("left-avatar-inactive");
            this.rightArrow.texture = new Texture.from("right-avatar-inactive");
        }
    }

    onArrowPressed(dir, ignore){
        this.setColourWheel();

        this.index += dir;

        if (this.index >= this.parts[0][0].length){
            this.index = 0;
        }
        if (this.index < 0){
            this.index = this.parts[0][0].length - 1;
        }
        for (var i = 0; i < this.parts.length; i++){
            this.dna[this.type[i]] = this.parts[i][0][this.index];
        }
        this.nextObject.texture = new Texture.from(this.getIcon(this.index + 1));
        this.previousObject.texture = new Texture.from(this.getIcon(this.index - 1));

        avatarGenerator.dna = this.dna;
        avatarGenerator.updateAnimations();

        if (!ignore){
            this.creator.onCarouselSelected(this);
        }
    }

    animateArrowsIn(){
        app.tween(this.leftArrow)
            .to({x: -(app.resizer.width / 2)}, 400, createjs.Ease.getElasticIn(1.1, 1.5));

        app.tween(this.rightArrow)
            .to({x: (app.resizer.width / 2)}, 400, createjs.Ease.getElasticIn(1.1, 1.5))
    }

    getIcon(index){
        if (index >= this.parts[0][0].length){
            index = 0;
        }
        if (index < 0){
            index = this.parts[0][0].length - 1;
        }
        return  avatarConfig.parts[this.type[0]][this.parts[0][0][index]].icon;
    }

    setColourWheel(){
        if (this.color){
            this.creator.colorWheel.setupColorWheel(this.color);
        }
    }

    setInitialPos(type){
        let int = this.parts[0][0].indexOf(avatarGenerator.dna[type[0]]);
        this.index = int;
        this.onArrowPressed(0, true);
    }
}
